<template>
  <ts-loading-banner :loading="loading">
    <div class="view-account">
      <section class="module">
        <div class="module-inner">
          <!-- folder tree  -->
          <folder-tree
            :data="data"
            v-if="!loading"
            @fetchNavi="fetch"
          ></folder-tree>

          <!-- content panel  -->
          <content-panel ref="contentPanel" @fetchNavi="fetch"></content-panel>
        </div>
      </section>
    </div>
  </ts-loading-banner>
</template>
<script>
import FolderTree from './components/folder-tree.vue'
import ContentPanel from './components/content-panel.vue'
export default {
  name: 'fileManager',
  components: {
    FolderTree,
    ContentPanel
  },
  data () {
    return {
      loading: false,
      data: []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      this.$store
        .dispatch('fileManager/fileBrowser/getFolderTree')
        .then(response => {
          this.data = response.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit(
        'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
        to.params.id
      )
    })
  }
}
</script>
